
import { Model } from './model';

export class ScenarioModel implements Model {

  name: string;
  id: string;
  sId: number;
  scenariosteps: string[];
  _type = "scenario";

}
